import type { WidgetProps } from '@takeshape/shape-form';
import { FieldWrapper } from '@takeshape/shape-form/widgets';
import { ToolQueryEditor } from './tool-query-editor.js';
import { type ToolQueryEditorOwnProps, useToolQueryEditor } from './tool-query-editor-hook.js';

function ToolQueryEditorWidget(props: WidgetProps<string>) {
  const hookProps = useToolQueryEditor(props as ToolQueryEditorOwnProps);
  return (
    <FieldWrapper label={props.label} required={props.required} error={props.error}>
      <ToolQueryEditor {...hookProps} />
    </FieldWrapper>
  );
}

export default ToolQueryEditorWidget;
